// apiService.ts
//
// Base URLs now come from src/config/env.ts (REACT_APP_API_BASE_URL /
// REACT_APP_ADMIN_LOGIN_BASE_URL), re-exported here so existing imports of
// API_BASE_URL/ADMIN_LOGIN_BASE_URL from this module keep working unchanged.

import { API_BASE_URL, ADMIN_LOGIN_BASE_URL } from "../config/env";

export { API_BASE_URL, ADMIN_LOGIN_BASE_URL };



const apiService = {
  get: async <T>(endpoint: string, queryParams: Record<string, any> = {}): Promise<T> => {
    const url = new URL(`${API_BASE_URL}/${endpoint}`);
    
    // Append query parameters
    Object.keys(queryParams).forEach(key => {
      url.searchParams.append(key, queryParams[key]);
    });

    try {
      const response = await fetch(url.toString());
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }
      return await response.json() as T;
    } catch (error) {
      throw error;
    }
  },

  post: async <T>(endpoint: string, data: any): Promise<T> => {
    const url = `${API_BASE_URL}/${endpoint}`;
  //  console.log(data, "FFDFDFD");

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          // 'Content-Type': 'application/json',
          'Content-Type': 'multipart/form-data',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return await response.json() as T;
    } catch (error) {
      throw error;
    }
  },

  patch: async <T>(endpoint: string, data: any): Promise<T> => {
    const url = `${API_BASE_URL}/${endpoint}`;

    try {
      const response = await fetch(url, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return await response.json() as T;
    } catch (error) {
      throw error;
    }
  },


  put: async <T>(endpoint: string, data: any): Promise<T> => {
    const url = `${API_BASE_URL}/${endpoint}`;

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return await response.json() as T;
    } catch (error) {
      throw error;
    }
  },

  delete: async <T>(endpoint: string): Promise<T> => {
    const url = `${API_BASE_URL}/${endpoint}`;

    try {
      const response = await fetch(url, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      return await response.json() as T;
    } catch (error) {
      throw error;
    }
  },
};

export default apiService;
